import { Data, Model } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import ExchangeLookup from "../Exchanges/Models/ExchangeLookup";

export interface IExchangeApiClient {
    getExchangeLookupListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<ExchangeLookup>>>;
    getExchangeLookupByID(exchangeID: number): AxiosPromise<Model.PlainObject<ExchangeLookup>>;
}

@injectable()
export default class ExchangeApiClient extends Data.ApiClientBase implements IExchangeApiClient {
    
    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/Exchange`)
    }

    public getExchangeLookupListByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<ExchangeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetExchangeLookupListByCriteria`, { params: { criteria: criteria }});
    }

    public getExchangeLookupByID(exchangeID: number): AxiosPromise<Model.PlainObject<ExchangeLookup>> {
        return this.axios.get(`${this.apiPath}/GetExchangeLookupByID`, { params: { exchangeID: exchangeID }});
    }
}